import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import TransactionalIndexController from 'cio/pods/transactional/index/controller';
import TransactionalMessageModel from 'cio/models/transactional-message';
import FeaturesService from 'ember-feature-flags/services/features';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export default class TransactionalMessagesIndex extends Route {
  @service features!: FeaturesService;
  @service store!: DS.Store;

  model() {
    return this.store.findAll('transactional-message');
  }

  setupController(
    controller: TransactionalIndexController,
    model: TransactionalMessageModel[],
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);
    controller.setDefaults();
  }

  @action
  reloadModel() {
    this.store.unloadAll('transactional-message');
    return this.refresh();
  }
}
